module.exports = __webpack_public_path__ + "img/rail.265ff3b6.jpg";